import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-start-layout',
    templateUrl: './start-layout.component.html',
    styleUrls: ['./start-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StartLayoutComponent implements OnInit {
  constructor() {
  }

  ngOnInit(): void {

  }


}
